import { messageLevel } from '../lib/MessagePopupOld';
import { receive_context, receive_database, receive_kwargs, receive_spatial_settings, receive_vars } from './receive';

export const LOAD_DATABASE = 'LOAD_DATABASE';
export const doLoadDatabase = (database, databaseLabel, models, ensembles, experiments, frequencies, variables, config) => ({
  type: LOAD_DATABASE,
  database,
  databaseLabel,
  models,
  ensembles,
  experiments,
  frequencies,
  variables,
  config,
});

export const LOAD_CONTEXT = 'LOAD_CONTEXT';
export const doLoadContext = (mode, user, urls) => ({
  type: LOAD_CONTEXT,
  mode,
  user,
  urls,
});

export const SHOW_ERROR = 'SHOW_ERROR';
export const showError = (message) => ({
  type: SHOW_ERROR,
  message,
  // type: TOGGLE_MESSAGE,
  // message,
  // level: messageLevel.ERROR
});

export const SHOW_SPINNER = 'SHOW_SPINNER';
export const showSpinner = (enable) => ({
  type: SHOW_SPINNER,
  enable,
});

export const TOGGLE_MESSAGE = 'TOGGLE_MESSAGE';
export const toggleMessage = (message, level) => ({
  type: TOGGLE_MESSAGE,
  message,
  level,
});

export const UPDATE_LANG = 'UPDATE_LANG';
export const updateLang = (lang) => ({
  type: UPDATE_LANG,
  lang,
});

export const UPDATE_VARIABLES = 'UPDATE_VARIABLES';
const doUpdateVariables = (variables) => ({
  type: UPDATE_VARIABLES,
  variables,
});

export const loadPageData = () => {
  return async (dispatch) => {
    try {
      const kwargs = await receive_kwargs();
      const database = kwargs.climate_database;

      const json = await receive_context(database);
      const { mode, user, urls } = json;
      dispatch(doLoadContext(mode, user, urls));
    } catch (error) {
      dispatch(toggleMessage('Could not communicate with server.', messageLevel.ERROR));
    }
  };
};

export const loadPageDataWithDatabase = () => {
  return async (dispatch) => {
    dispatch(loadPageData());

    try {
      const kwargs = await receive_kwargs();
      const database = kwargs.climate_database;

      const json = await receive_database(database);
      const { label, models, ensembles, experiments, frequencies, variables, config } = json;
      dispatch(doLoadDatabase(database, label, models, ensembles, experiments, frequencies, variables, config));
    } catch (error) {
      dispatch(toggleMessage('Could not retrieve database information.', messageLevel.ERROR));
    }
  };
};

export const receiveSpatialSettings = () => {
  return (async () => {
    const kwargs = await receive_kwargs();
    const database = kwargs.climate_database;
    return await receive_spatial_settings(database);
  })();
};

export const updateVariables = ({database, model, ensemble, experiment, frequency, all}) => {
  return async (dispatch) => {
    try {
      const json = await receive_vars({database, model, ensemble, experiment, frequency, all});
      dispatch(doUpdateVariables(json.variables));
    } catch (error) {
      dispatch(toggleMessage('Could not retrieve variables information.', messageLevel.ERROR));
    }
  };
};
